// @ts-nocheck
import { getRenderElement, setDefaults } from '@udecode/slate-plugins';
import { DEFAULTS_BBK_EXPRESSION } from './defaults';

export const renderElementBbkExpression = (options?) => {
  const { bbkExpression } = setDefaults(options, DEFAULTS_BBK_EXPRESSION);

  return getRenderElement(bbkExpression);
};
